<script setup lang="ts">
import { computed } from 'vue'
import { ExclamationTriangleIcon, ShieldExclamationIcon, ServerIcon } from '@heroicons/vue/24/solid'
import { useTranslations } from '@/composables/useTranslations.ts'
import { useRouter } from 'vue-router'
import { usePageTitle } from '@/composables/usePageTitle.ts'
import { ErrorName } from '@/enums.ts'

const props = defineProps<{ errorName: ErrorName }>()
const { t } = useTranslations()
const router = useRouter()

const onGoBackButtonClick = () => {
  if (window.history.state.back) {
    router.go(-1)
  } else {
    router.push('/')
  }
}

const errorsMap = computed<Record<string, { // TODO: All to enum
  component: any,
  title: string,
  description: string
}>>(() => ({
  [ErrorName.NotFound]: {
    component: ExclamationTriangleIcon,
    title: t('errorPage.error404'),
    description: t('errorPage.error404description')
  },
  [ErrorName.ProjectNotFound]: {
    component: ExclamationTriangleIcon,
    title: t('errorPage.error404'),
    description: t('errorPage.error404description')
  },
  [ErrorName.UserNotFound]: {
    component: ExclamationTriangleIcon,
    title: t('errorPage.error404'),
    description: t('errorPage.error404description')
  },
  forbidden: {
    component: ShieldExclamationIcon,
    title: t('errorPage.error403'),
    description: t('errorPage.error403description')
  },
  'server-error': {
    component: ServerIcon,
    title: t('errorPage.error500'),
    description: t('errorPage.error500description')
  },
  default: {
    component: ServerIcon,
    title: t('errorPage.errorUnknown'),
    description: t('errorPage.errorUnknownDescription')
  },
}))
const error = computed(() => {
  return errorsMap.value[props.errorName] ?? errorsMap.value['default']
})
const title = computed(() => {
  // @ts-expect-error Jevgeni fix it later
  return (errorsMap.value[props.errorName] ?? errorsMap.value['default']).title
})

usePageTitle(title)
</script>

<template>
  <div class="flex flex-col items-center justify-center py-40 h-full">
    <div class="animate__animated animate__headShake flex flex-col items-center" v-if="error">

      <component :is="error?.component" class="w-24 h-24 mb-4 text-red-500" />
      <h1 class="text-4xl font-bold mb-4">{{ error.title }}</h1>
      <p class="text-xl text-gray-600 mb-8">{{ error.description }}</p>
      <button
        @click="onGoBackButtonClick"
        class="bg-blue-500 hover:bg-blue-600 text-white px-6 py-3 rounded-lg transition-colors"
      >
        {{ t('errorPage.goToMainPage') }}
      </button>
    </div>
  </div>
</template>

<style scoped>
</style>
